// extracted by mini-css-extract-plugin
module.exports = {"title":"index_title_2y05H","block":"index_block_Ll4cg","inner":"index_inner_aaW-Y","form":"index_form_1JFOF"};